
import {PERMISSIONS} from './APP_CONSTANTS';

export const SALES_REP_PERMISSIONS = [
    PERMISSIONS.hide_only_actions_tab,
    PERMISSIONS.view_only_product_delivery_type,
    PERMISSIONS.hide_only_pending_collections_button,
    PERMISSIONS.hide_only_sidebar_menuItems,
    PERMISSIONS.view_only_salesrep_search_page,
    PERMISSIONS.view_only_sidebar_expanded,

    PERMISSIONS.view_only_instructor_navigation_button
];
export const LSA_PREMISSIONS = [
    PERMISSIONS.hide_only_sidebar,
    PERMISSIONS.hide_only_pending_collections_button,
];

export const PROJECT_SPECIALIST_PERMISSIONS = [
    PERMISSIONS.hide_only_loaderIndicator,
];

export const ROLE_PERMISSIONS = {
    project_specialist : PROJECT_SPECIALIST_PERMISSIONS,
    lsa : LSA_PREMISSIONS,
    sales_rep : SALES_REP_PERMISSIONS
};


// WEBPACK FOOTER //
// ./src/constants/permissionsConstants.js